import schema, { generateType } from './Schema';
export const EcommerceCategory = generateType(schema.getModel('ecommerceCategory'));
//# sourceMappingURL=EcommerceCategoryModel.js.map